export default __webpack_public_path__ + "static/media/Checkmark.f2f3dd9b.svg";